import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const preferredLanguageSlice = createSlice({
  name: "preferredLanguage",
  initialState: "",
  reducers: {
    setPreferredLanguage: (_state: string, action: PayloadAction<string>) => action.payload,
  },
});

export const { setPreferredLanguage } = preferredLanguageSlice.actions;
export default preferredLanguageSlice.reducer;
